var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberThreeFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberThreeFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM12.5233 6.30357H11.3447C10.6603 6.30334 9.99454 6.52651 9.44855 6.93919C8.90257 7.35187 8.50621 7.9315 8.31971 8.59C8.24886 8.84069 8.2805 9.10925 8.40766 9.33661C8.53483 9.56397 8.7471 9.73151 8.99779 9.80236C9.24847 9.87321 9.51704 9.84157 9.7444 9.71441C9.97176 9.58724 10.1393 9.37497 10.2101 9.12429C10.2803 8.8775 10.429 8.66033 10.6338 8.50576C10.8385 8.35119 11.0882 8.26767 11.3447 8.26786H12.5233C12.8359 8.26786 13.1356 8.39203 13.3567 8.61305C13.5777 8.83408 13.7019 9.13385 13.7019 9.44643C13.7019 9.759 13.5777 10.0588 13.3567 10.2798C13.1356 10.5008 12.8359 10.625 12.5233 10.625H11.934C11.6735 10.625 11.4237 10.7285 11.2395 10.9127C11.0553 11.0969 10.9519 11.3467 10.9519 11.6071C10.9519 11.8676 11.0553 12.1174 11.2395 12.3016C11.4237 12.4858 11.6735 12.5893 11.934 12.5893H12.7197C13.4787 12.5893 14.0947 13.2053 14.0947 13.9643V14.3571C14.0947 14.7218 13.9498 15.0716 13.692 15.3294C13.4341 15.5873 13.0844 15.7321 12.7197 15.7321H11.1483C10.8638 15.7323 10.5862 15.6443 10.3538 15.4802C10.1213 15.3162 9.94545 15.0841 9.85029 14.816C9.75743 14.5787 9.57602 14.3869 9.34435 14.2809C9.11268 14.1748 8.84888 14.163 8.60865 14.2478C8.36842 14.3327 8.17055 14.5076 8.05682 14.7355C7.9431 14.9635 7.92242 15.2268 7.99914 15.4697C8.22948 16.1209 8.65598 16.6846 9.21994 17.0834C9.7839 17.4822 10.4576 17.6963 11.1483 17.6964H12.7197C13.6053 17.6964 14.4547 17.3446 15.0809 16.7184C15.7072 16.0921 16.059 15.2428 16.059 14.3571V13.9643C16.0594 13.4915 15.9591 13.024 15.7648 12.5929C15.5706 12.1618 15.2868 11.7771 14.9323 11.4641C15.3162 11.0056 15.5614 10.447 15.639 9.85402C15.7165 9.26101 15.6233 8.65818 15.3702 8.11632C15.117 7.57445 14.7146 7.11606 14.21 6.79496C13.7055 6.47386 13.1198 6.30339 12.5217 6.30357H12.5233Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberThreeFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberThreeFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberThreeFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-three-filled') === undefined) {
    customElements.define('cat-icon-number-three-filled', BlocksIconNumberThreeFilled);
}
